// Master Apps · ordem do deck — persistida em localStorage.
//
// A sequência dos slides nasce da ÁREA SOLICITANTE (ver `deckOrdemPorArea`), e
// o apresentador pode arrastar para montar a ordem que quiser. O que ele montar
// tem de continuar valendo depois de fechar a apresentação: é ensaio de
// reunião, não filtro do momento — sair da tela e perder a ordem obrigaria a
// remontar tudo antes de projetar.
//
// É por isso que este store persiste e o `useDeckFilters` não: lá, "quem eu vou
// apresentar hoje" é pergunta do dia (o comentário do próprio hook explica), e
// aqui "em que ordem eu conto a história" é decisão que se toma uma vez.
//
// Guarda IDS, não posições: ficha nova, ficha apagada ou filtro ligado não
// embaralham o resto — `deckAplicarOrdem` resolve quem não está na lista.
import { create } from 'zustand';

const STORAGE_KEY = 'master-apps:deck-order';

interface DeckOrderState {
  /** Ids na ordem escolhida à mão. Vazio = ninguém arrastou; vale a ordem por área. */
  ordem: string[];
  /** true quando existe ordem manual — a tela precisa oferecer o "restaurar". */
  personalizada: boolean;
  salvarOrdem: (ids: readonly string[]) => void;
  /** Volta para a ordem por área solicitante. */
  restaurarPadrao: () => void;
}

function load(): string[] {
  if (typeof localStorage === 'undefined') return [];
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    // Id repetido colocaria a mesma plataforma em dois lugares da sequência —
    // e `deckAplicarOrdem` respeitaria só o primeiro, silenciosamente.
    const vistos = new Set<string>();
    for (const v of parsed) {
      if (typeof v === 'string' && v !== '') vistos.add(v);
    }
    return [...vistos];
  } catch {
    return [];
  }
}

function persist(ids: readonly string[]): void {
  try {
    if (ids.length === 0) localStorage.removeItem(STORAGE_KEY);
    else localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  } catch {
    // localStorage cheio/bloqueado: a ordem só não sobrevive ao reload.
  }
}

const inicial = load();

export const useDeckOrder = create<DeckOrderState>((set) => ({
  ordem: inicial,
  personalizada: inicial.length > 0,
  salvarOrdem: (ids) => {
    const lista = [...ids];
    persist(lista);
    set({ ordem: lista, personalizada: lista.length > 0 });
  },
  restaurarPadrao: () => {
    persist([]);
    set({ ordem: [], personalizada: false });
  },
}));
